import { render } from "./ViewPage.vue?vue&type=template&id=2705c457&scoped=true"
import script from "./ViewPage.vue?vue&type=script&lang=js"
export * from "./ViewPage.vue?vue&type=script&lang=js"

import "./ViewPage.vue?vue&type=style&index=0&id=2705c457&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2705c457"]])

export default __exports__